import { OfferingMenuFeatures, OfferingMenuPermissions } from 'modules/shared-menu/types';

export const SHARED_MENU_DEFAULT_PERMISSIONS: OfferingMenuPermissions = {
  catalogCreate: true,
  catalogRead: true,
  categoryImages: true,
  csvItemImport: true,
  csvItemUpdate: true,
  csvItemPriceUpdate: true,
  customCommissionEdit: true,
  customCommissionRead: true,
  discount: true,
  contentEdit: true,
  exportImport: true,
  itemExportImport: true,
  itemVatChange: true,
  menuSync: true,
  posIdField: true,
  systemIdRead: true,
  woltSpecials: true,
};

const VENUE_LEVEL_SPECIFIC_FEATURES: Pick<
  OfferingMenuFeatures,
  'posIntegration' | 'inventoryManagement' | 'hasPickerEnabled'
> = {
  posIntegration: false,
  inventoryManagement: false,
  hasPickerEnabled: false,
};

export const SHARED_MENU_DEFAULT_FEATURES: OfferingMenuFeatures = {
  ...VENUE_LEVEL_SPECIFIC_FEATURES,
  isRetail: true,
  bottleDeposits: true,
  hasCatalogSource: true,
  bundleItems: true,
  overTheCounter: true,
  extendedUsageInstructions: true,
  categoryImages: true,
  hasReturnPoliciesEnabled: true,
  hasWoltPlusSpecialsEnabled: true,
  supportWeightedItems: true,
  mandatoryWarnings: true,
  overTheCounterHyperlinkAllowed: true,
  restockingRulesEnabled: true,
  externalInfoHyperlinkAllowed: true,
  externalHelpCenterLinkEnabled: true,
};
